import { render, staticRenderFns } from "./courseOrder.vue?vue&type=template&id=5f873334"
import script from "./courseOrder.vue?vue&type=script&lang=js"
export * from "./courseOrder.vue?vue&type=script&lang=js"
import style0 from "./courseOrder.vue?vue&type=style&index=0&id=5f873334&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports